window.prazdnyKosikNadpis = [
  { language: "cs", text: "Váš košík je prázdný." },
  { language: "en", text: "Your cart is empty." },
  { language: "de", text: "Ihr Warenkorb ist leer." },
];

window.prazdnyKosikPerex = [
  {
    language: "cs",
    text: "Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte přímo nám, rádi vám pomůžeme.",
  },
  {
    language: "en",
    text: "If you don't know which product to choose, try looking at our advice section or call us directly, we will be happy to help you.",
  },
  {
    language: "de",
    text: "Wenn Sie nicht wissen, welches Produkt Sie wählen sollen, schauen Sie in unseren Beratungsbereich oder rufen Sie uns direkt an, wir helfen Ihnen gerne weiter.",
  },
];

window.primaryButtonText = [
  { language: "cs", text: "Zpět do obchodu", url: "/" },
  { language: "en", text: "Back to shop", url: "/" },
  { language: "de", text: "Zurück zum Shop", url: "/" },
];

window.secondaryButtonText = [
  { language: "cs", text: "Kontakty", url: "/kontakty" },
  { language: "en", text: "Contacts", url: "/kontakty" },
  { language: "de", text: "Kontakte", url: "/kontakty" },
];

window.emailPerexText = [
  { language: "cs", text: "Odpovídáme do 24 hodin" },
  { language: "en", text: "We respond within 24 hours" },
  { language: "de", text: "Wir antworten innerhalb von 24 Stunden" },
];

window.recenzeBtnText = [
  { language: "cs", text: "Zobrazit vše" },
  { language: "en", text: "Show more" },
  { language: "de", text: "Alles anzeigen" },
];

window.hodnoceniNadpis = [
  { language: "cs", text: "Zpětná vazba" },
  { language: "en", text: "Feedback" },
  { language: "de", text: "Feedback" },
];

window.dopravaVHlavicce = [
  { language: "cs", text: "Doprava zdarma od 999 Kč" },
  { language: "en", text: "Free shipping from 999 CZK" },
  { language: "de", text: "Kostenloser Versand ab 999 CZK" },
];

window.kosik = [
  { language: "cs", text: "Košík" },
  { language: "en", text: "Cart" },
  { language: "de", text: "Warenkorb" },
];

window.availabilityTitle = [
  { language: "cs", text: "Dostupnost" },
  { language: "en", text: "Availability" },
  { language: "de", text: "Verfügbarkeit" },
];

window.extraGiftTitles = [
  { language: "cs", text: "Dárky a slevy" },
  { language: "en", text: "Gifts and discounts" },
  { language: "de", text: "Geschenke und Rabatte" },
];

window.itemsCartTitle = [
  { language: "cs", text: "Nákupní košík" },
  { language: "en", text: "Shopping cart" },
  { language: "de", text: "Einkaufswagen" },
];

window.productDetailAddBtn = [
  { language: "cs", text: "DARUJ" },
  { language: "en", text: "GIVE" },
  { language: "de", text: "GEBEN" },
];

window.productDetailFavourite = [
  { language: "cs", text: "Přidat do oblíbených", remove: "Odebrat" },
  { language: "en", text: "Add to favorites", remove: "Remove" },
  { language: "de", text: "Zu Favoriten hinzufügen", remove: "Entfernen" },
];

window.filterBtnText = [
  { language: "cs", text: "Filtrace" },
  { language: "en", text: "Filtering" },
  { language: "de", text: "Filterung" },
];

window.filterBtnTextClose = [
  { language: "cs", text: "Zavřít filtraci" },
  { language: "en", text: "Close filtering" },
  { language: "de", text: "Filterung schließen" },
];

window.newsBtnText = [
  { language: "cs", text: "Zobrazit článek" },
  { language: "en", text: "Show article" },
  { language: "de", text: "Artikel anzeigen" },
];

window.alternativeNadpis = [
  { language: "cs", text: "Podobné produkty" },
  { language: "en", text: "Similar products" },
  { language: "de", text: "Ähnliche Produkte" },
];

window.newsLetterTitle = [
  { language: "cs", text: "Aktuální novinky <br> a akce na váš e-mail" },
  { language: "en", text: "Current news <br> and promotions to your email" },
  {
    language: "de",
    text: "Aktuelle Nachrichten <br> und Aktionen an Ihre E-Mail",
  },
];

window.newsLetterPerex = [
  {
    language: "cs",
    text: "Získejte exkluzivní novinky, speciální nabídky a přehled o nejnovějších modelech hodinek přímo do své schránky. Přihlaste se k odběru našeho newsletteru.",
  },
  {
    language: "en",
    text: "Get exclusive news, special offers and an overview of the latest watch models directly to your inbox. Subscribe to our newsletter.",
  },
  {
    language: "de",
    text: "Erhalten Sie exklusive Nachrichten, Sonderangebote und einen Überblick über die neuesten Uhrenmodelle direkt in Ihren Posteingang. Abonnieren Sie unseren Newsletter.",
  },
];

window.newsLetterBtn = [
  { language: "cs", text: "Odebírat newsletter" },
  { language: "en", text: "Subscribe to newsletter" },
  { language: "de", text: "Newsletter abonnieren" },
];

window.specificationTabText = [
  { language: "cs", text: "Specifikace" },
  { language: "en", text: "Specifications" },
  { language: "de", text: "Spezifikationen" },
];

window.subcategoriesBtnCategory = [
  { language: "cs", text: "Značky" },
  { language: "en", text: "Brands" },
  { language: "de", text: "Marken" },
];

window.filteringMobileBtnText = [
  { language: "cs", text: "Filtrovat" },
  { language: "en", text: "Filter" },
  { language: "de", text: "Filtern" },
];

window.flagsIcons = [
  {
    language: "cs",
    imgUrl: "/user/documents/upload/newDesign/flags/flag-cz.svg",
  },
  {
    language: "en",
    imgUrl: "/user/documents/upload/newDesign/flags/flag-us.svg",
  },
  {
    language: "de",
    imgUrl: "/user/documents/upload/newDesign/flags/flag-uk.svg",
  },
];

// window.blogOnHpTitle = [
//   { language: "cs", text: "Společně jsme zachránili" },
//   { language: "en", text: "Together we saved" },
//   { language: "de", text: "Gemeinsam haben wir gerettet" },
// ];

window.blogOnHpLink = [
  { language: "cs", text: "Zobrazit blog", url: "/smutny-pribeh-nasej-river" },
  { language: "en", text: "View blog", url: "/smutny-pribeh-nasej-river" },
  { language: "de", text: "Blog anzeigen", url: "/smutny-pribeh-nasej-river" },
];

// window.cartDeliveryTitle = [
//   { language: "cs", text: "Vyberte útulek, do kterého chcete doručit zboží" },
//   {
//     language: "en",
//     text: "Select the shelter to which you want to deliver the goods",
//   },
//   {
//     language: "de",
//     text: "Wählen Sie das Tierheim aus, in das Sie die Waren liefern möchten",
//   },
// ];

window.cartContinueBtn = [
  { language: "cs", text: "Pokračovat v objednávce" },
  { language: "en", text: "Continue" },
  { language: "de", text: "Fortsetzen" },
];

window.searchText = [
  { language: "cs", text: "Hledat" },
  { language: "en", text: "Search" },
  { language: "de", text: "Search" },
];

window.catalogLinks = {
  cs: [
    {
      text: "Výprodej",
      url: "/vyprodej",
      image: "",
    },
    {
      text: "Akce",
      url: "/akce",
      image: "",
    },
   {
    text: "Lopaty <br> pro nakladače",
    url: "/lopaty-nakladacove/",
    image: "/user/documents/upload/navigace/footer-icon-1.png"
  }, {
    text: "Lžíce <br> pro rýpadla",
    url: "/lzice-podkopove/",
    image: "/user/documents/upload/navigace/footer-icon-2.png"
  }, {
    text: "Rychloupínače",
    url: "/rychloupinace-pro-rypadla/",
    image: "/user/documents/upload/navigace/footer-icon-3.png"
  }, {
    text: "Zuby a zubové<br> systémy",
    url: "/zuby-a-zubove-systemy",
    image: "/user/documents/upload/navigace/footer-icon-4.png"
  }, {
    text: "Pásy gumové",
    url: "/pasy-gumove",
    image: "/user/documents/upload/navigace/footer-icon-5.png"
  }, {
    text: "Kladiva<br> hydraulická",
    url: "/kladiva-renomag-xr/",
    image: "/user/documents/upload/navigace/footer-icon-6.png"
  }, {
    text: "Díly<br> podvozkové",
    url: "/dily-podvozkove/",
    image: "/user/documents/upload/navigace/footer-icon-7.png"
  },
  ],
  en: [
    {
      text: "Sale",
      url: "/sale",
      image: "",
    },
    {
      text: "Special offer",
      url: "/special-offer",
      image: "",
    },
    {
      text: "Buckets for loaders",
      url: "/buckets-for-loaders",
      image: "/user/documents/upload/navigace/nav-icon-1.png",
    },
    {
      text: "Buckets for excavators",
      url: "/buckets-for-excavators",
      image: "/user/documents/upload/navigace/nav-icon-2.png",
    },
    {
      text: "Quick couplers",
      url: "/quick-couplers",
      image: "/user/documents/upload/navigace/nav-icon-3.png",
    },
    {
      text: "Teeth and tooth systems",
      url: "/teeth-and-tooth-systems",
      image: "/user/documents/upload/navigace/nav-icon-4.png",
    },
    {
      text: "Rubber tracks",
      url: "/rubber-tracks",
      image: "/user/documents/upload/navigace/nav-icon-5.png",
    },
    {
      text: "Hydraulic hammers",
      url: "/hydraulic-hammers",
      image: "/user/documents/upload/navigace/nav-icon-6.png",
    },
    {
      text: "Undercarriage parts",
      url: "/undercarriage-parts",
      image: "/user/documents/upload/navigace/nav-icon-7.png",
    },
  ],
  de: [
    {
      text: "Ausverkauf",
      url: "/ausverkauf",
      image: "",
    },
    {
      text: "Aktion",
      url: "/aktion",
      image: "",
    },
    {
      text: "Schaufeln für Lader",
      url: "/schaufeln-fuer-lader",
      image: "/user/documents/upload/navigace/nav-icon-1.png",
    },
    {
      text: "Löffel für Bagger",
      url: "/loeffel-fuer-bagger",
      image: "/user/documents/upload/navigace/nav-icon-2.png",
    },
    {
      text: "Schnellwechsler",
      url: "/schnellwechsler",
      image: "/user/documents/upload/navigace/nav-icon-3.png",
    },
    {
      text: "Zähne und Zahnsysteme",
      url: "/zaehne-und-zahnsysteme",
      image: "/user/documents/upload/navigace/nav-icon-4.png",
    },
    {
      text: "Gummiketten",
      url: "/gummiketten",
      image: "/user/documents/upload/navigace/nav-icon-5.png",
    },
    {
      text: "Hydraulikhämmer",
      url: "/hydraulikhaemmer",
      image: "/user/documents/upload/navigace/nav-icon-6.png",
    },
    {
      text: "Fahrwerkteile",
      url: "/fahrwerkteile",
      image: "/user/documents/upload/navigace/nav-icon-7.png",
    },
  ],
};
window.catalogButtonLink = [
  { language: "cs", text: "Katalog" },
  { language: "en", text: "Catalogue" },
  { language: "de", text: "Katalog" },
];
window.detailTitle = [
  { language: "cs", text: "Detail produktu" },
  { language: "en", text: "Product detail" },
  { language: "de", text: "Produktdetails" },
];

window.parametersTitle = [
  { language: "cs", text: "Technická specifikace" },
  { language: "en", text: "Technical specification" },
  { language: "de", text: "Technische Spezifikation" },
];

window.parametersParametr = [
  { language: "cs", text: "Název parametru" },
  { language: "en", text: "Parameter name" },
  { language: "de", text: "Parametername" },
];

window.parametersParametrText = [
  { language: "cs", text: "Parametr" },
  { language: "en", text: "Parameter" },
  { language: "de", text: "Parameter" },
];
window.ratingTitle = [
  { language: "cs", text: "Hodnocení" },
  { language: "en", text: "Rating" },
  { language: "de", text: "Bewertung" },
];
window.discussionTitle = [
  { language: "cs", text: "Diskuze" },
  { language: "en", text: "Discussion" },
  { language: "de", text: "Diskussion" },
];
window.relatedFilesTitle = [
  { language: "cs", text: "Ke stažení" },
  { language: "en", text: "Downloads" },
  { language: "de", text: "Downloads" },
];
window.relatedProductsTitle = [
  { language: "cs", text: "Doporučujeme" },
  { language: "en", text: "Recommended" },
  { language: "de", text: "Empfohlen" },
];
window.projectPhoneTime = [
  { language: "cs", text: "<span> Po-Pá</span><span> 07:30 - 16:00</span>" },
  {
    language: "en",
    text: "<span> Mon-Fri</span><span> 07:30 am - 4:00 pm</span>",
  },
  { language: "de", text: "<span> Mo-Fr</span><span> 07:30 - 16:00</span>" },
];

window.stepBackText = [
  { language: "cs", text: "Zpět k nákupnímu košíku" },
  { language: "en", text: "Back to shopping cart" },
  { language: "de", text: "Zurück zum Warenkorb" },
];
window.backHomepageBtn = [
  { language: "cs", text: "Zpět k nákupu", url: "/" },
  { language: "en", text: "Back to shopping", url: "/" },
  { language: "de", text: "Zurück zum Einkauf", url: "/" },
];
window.shippingTitle = [
  { language: "cs", text: "Způsob dopravy" },
  { language: "en", text: "Shipping method" },
  { language: "de", text: "Versandart" },
];

window.paymentTitle = [
  { language: "cs", text: "Způsob platby" },
  { language: "en", text: "Payment method" },
  { language: "de", text: "Zahlungsart" },
];
window.stepBackToShippingPayment = [
  { language: "cs", text: "Zpět k dopravě a platbě" },
  { language: "en", text: "Back to shipping and payment" },
  { language: "de", text: "Zurück zu Versand und Zahlung" },
];
window.links = [
  {
    language: "cs",
    links: [
      {
        name: "Na kategorii",
        url: "/brity-a-profily-pro-stavebni-techniku/",
        index: 0,
      },
      { name: "Na kategorii", url: "/haky-k-navareni/", index: 1 },
      { name: "Na kategorii", url: "/akcni-nabidka/", index: 2 },
    ],
  },
  {
    language: "en",
    links: [
      { name: "Na kategorii", url: "/", index: 0 },
      { name: "Na kategorii", url: "/", index: 1 },
      { name: "Na kategorii", url: "/", index: 2 },
    ],
  },
];
window.categoryFilterTitleTags = [
  { language: "cs", text: "Příznaky" },
  { language: "en", text: "Příznaky" },
  { language: "de", text: "Příznaky" },
];
window.showMoreLessTexts = [
  { language: "cs", more: "Ukázat více", less: "Skrýt popis" },
  { language: "en", more: "Show more", less: "Show less" },
  { language: "de", more: "Mehr anzeigen", less: "Weniger anzeigen" },
];
window.instagramTitle = [
  { language: "cs", text: "Instagramové příspěvky" },
  { language: "en", text: "Instagram posts" },
  { language: "de", text: "Instagram-Beiträge" },
];
window.anotherSubcategorie = [
  { language: "cs", text: "Příbuzné kategorie" },
  { language: "en", text: "Related categories" },
  { language: "de", text: "Verwandte Kategorien" },
];
